export enum WarningMessages {
  MULTIPLE = 'Multiple warnings',
  HANDOFF_NOT_EXIST = 'Handoff used does not exist',
  FUNCTION_NOT_EXIST = "Function doesn't exist",
  SMS_NOT_EXIST = 'SMS template used does not exist',
  ATTRIBUTE_NOT_EXIST = 'Attribute used does not exist',
  ENTITY_NOT_EXIST = 'Entity used does not exist',
  VARIABLE_NOT_EXIST = 'Variable used does not exist',
  FUNCTION_HAS_ERRORS = 'Function contains errors',
  TRANSLATION_NOT_EXIST = 'Translation used does not exist',
}
